import React from "react"
import game from "octi.png"

const Octi = props => <img src={game} className="game" {...props} />

export default Octi
